import { Box, Grid, Typography } from "@mui/material";
import { DateTimeInput } from "components/FormControls/DateTimeInput";
import { FormSection } from "components/FormControls/FormSection";
import { NumberFormatInput } from "components/FormControls/NumberFormatInput";
import { OLSwitch } from "components/FormControls/Toggle";
import { useMessage } from "hooks/intl";
import { useState } from "react";
import { useStyles } from "../SimulateCampaign.styles";

interface Props {
  fieldNamePrefix: "customer" | "referrer";
  clearTransactionFields: () => void;
  isTransactionAttached?: boolean;
}

export const TransactionalHistory = ({
  fieldNamePrefix,
  isTransactionAttached,
  clearTransactionFields,
}: Props) => {
  const classes = useStyles();
  const { message } = useMessage();
  const [isOpen, setIsOpen] = useState(isTransactionAttached);

  return (
    <FormSection>
      <Box className={classes.sectionHeaderContainer}>
        <Typography className={classes.title}>
          {message({ id: "transactionalHistory" })}
        </Typography>
        <OLSwitch
          checked={isOpen}
          onChange={() => {
            if (isOpen) {
              clearTransactionFields();
            }
            setIsOpen(!isOpen);
          }}
          data-test-id="transactional-history-switch"
        />
      </Box>
      {isOpen ? (
        <Grid container spacing={12} mt={0}>
          <Grid item xs={6}>
            <DateTimeInput
              className={classes.input}
              defaultValue={null}
              format="yyyy-MM-dd HH:mmXXX"
              label={message({ id: "firstTransactionDate" })}
              name={`${fieldNamePrefix}.firstTransactionDate`}
              data-test-id="first-transaction-date"
              width="100%"
            />
          </Grid>
          <Grid item xs={6}>
            <DateTimeInput
              className={classes.input}
              defaultValue={null}
              format="yyyy-MM-dd HH:mmXXX"
              label={message({ id: "lastTransactionDate" })}
              name={`${fieldNamePrefix}.lastTransactionDate`}
              data-test-id="last-transaction-date"
              width="100%"
            />
          </Grid>
          <Grid item xs={6}>
            <NumberFormatInput
              className={classes.input}
              label={message({ id: "numberOfTransactions" })}
              name={`${fieldNamePrefix}.numberOfPurchases`}
              type="text"
              data-test-id="number-of-transactions"
              width="100%"
            />
          </Grid>
          <Grid item xs={6}>
            <NumberFormatInput
              allowDecimals
              className={classes.input}
              label={message({ id: "averageTransactionValue" })}
              name={`${fieldNamePrefix}.averagePurchaseAmount`}
              type="text"
              data-test-id="average-transaction-value"
              width="100%"
            />
          </Grid>
          <Grid item xs={12}>
            <NumberFormatInput
              allowDecimals
              className={classes.input}
              label={message({ id: "memberLifetimeValue" })}
              name={`${fieldNamePrefix}.purchaseAmount`}
              type="text"
              data-test-id="member-lifetime-value"
              width="100%"
            />
          </Grid>
        </Grid>
      ) : null}
    </FormSection>
  );
};
